import configs from '~/env.json'
import mixTheme, * as Themes from '~/assets/styles'
import { boticarioTheme, quemDisseBereniceTheme, vultTheme, gbInstitucionalTheme } from '@grupoboticario/flora'

const defaultBranch = configs?.REACT_APP_BRANCH || 'BOT'

const floraThemes = {
  BOT: boticarioTheme,
  QDB: quemDisseBereniceTheme,
  VULT: vultTheme,
  DEFAULT: gbInstitucionalTheme
}

/**
 * Gets the Material-UI theme options with customizations for the specified brand
 * @param {string} branch - Brand/branch to get theme for
 * @param {Object} previewLayoutCampaign - Preview layout theme customizations (takes precedence over layout)
 * @param {Object} layout - Default layout theme customizations
 * @returns {Object} Combined theme object for Material-UI
 */
export function getMuiThemeOptions(branch, previewLayoutCampaign, layout) {
  const selectedBranch = branch || defaultBranch
  const themeSource = previewLayoutCampaign || layout || Themes.defaultLayout(defaultBranch)
  return mixTheme(Themes[selectedBranch], themeSource)
}

/**
 * Returns the Flora theme for the specified brand
 * @param {string} branch - Brand/branch to get theme for
 * @returns {Object} Flora theme object
 */
export function getFloraThemeOptions(branch) {
  const selectedBranch = branch || defaultBranch
  return floraThemes[selectedBranch] || floraThemes.DEFAULT
}
